import NBType, { InferType } from '@netbase/nb-type'
import QuidSourceCategoryType from '../enums/QuidSourceCategoryType'
import QuidSourceGenreType from '../enums/QuidSourceGenreType'
import QuidSourceQualityType from '../enums/QuidSourceQualityType'
import QuidTopicTypeSchema from './QuidTopicTypeSchema'

const LxnxFilterSchema = NBType.object().shape('LxnxFilterSchema', {
  /* @prop */
  excludedSources: NBType.array().of(NBType.array().of(NBType.string())).nullable(),
  /* @prop */
  excludedSubjects: NBType.array().of(NBType.array().of(QuidTopicTypeSchema)).nullable(),
  /* @prop */
  includedSources: NBType.array().of(NBType.array().of(NBType.string())).nullable(),
  /* @prop */
  includedSubjects: NBType.array().of(NBType.array().of(QuidTopicTypeSchema)).nullable(),
  /* @prop */
  sourceTypeCategories: NBType.array().of(NBType.enum(QuidSourceCategoryType)).nullable(),
  /* @prop */
  sourceTypeGenres: NBType.array().of(NBType.enum(QuidSourceGenreType)).nullable(),
  /* @prop */
  sourceTypeQualities: NBType.array().of(NBType.enum(QuidSourceQualityType)).nullable()
  /* END */
})
export default LxnxFilterSchema
export type LxnxFilter = InferType<typeof LxnxFilterSchema>
// RESERVE BELOW
